var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"btn btn-xs btn-icon mr-2 btn-outline-danger",attrs:{"title":"Làm lại bài kiểm tra"},on:{"click":_vm.redoingTest}},[_c('i',{staticClass:"fa far fas fa-redo"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }